import { Component, OnInit } from '@angular/core';
import {AppComponent} from "../../app.component";
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-unauthorized-container',
  templateUrl: './unauthorized-container.component.html',
  styleUrls: ['./unauthorized-container.component.scss']
})
export class UnauthorizedContainerComponent implements OnInit {

  constructor(private rootApp: AppComponent) {
    if (!!environment.backgroundCssVariable) {
      this.rootApp.cssClass = this.rootApp.cssClass = `authentication-bg ${environment.backgroundCssVariable}`;
    } else {
      this.rootApp.cssClass = this.rootApp.cssClass = 'authentication-bg bg-gradient';
    }
  }

  ngOnInit() {

  }

}
